import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function PageHero() {
  const steps = [{
    text: "I’ll check current and upcoming listings."
  }, {
    text: "You’ll receive homes that match your budget and location."
  }, {
    text: "I’ll follow up if there are strong matches worth seeing quickly."
  }];
  return <section data-section-id="233235" id="confirmation-message" className="bg-background text-foreground py-[120px] md:py-[120px]">
      <div className="mx-auto max-w-5xl px-4 text-center md:px-6">
        <div className="mx-auto mb-8 flex h-16 w-16 items-center justify-center rounded-full border border-accent-gold bg-white/10 backdrop-blur-md shadow-lg">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="text-primary">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
        <h1 className="font-default text-foreground text-4xl font-bold md:text-5xl mb-6">
          We’re Checking Homes That Match Your Search
        </h1>
        <p className="font-sans text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto mb-8">Thanks — your request was received. I’ll review available homes near Naperville, including Lisle, Aurora, Oswego, Plainfield, and Bolingbrook.</p>
        
        <div className="max-w-md mx-auto text-left mb-10">
          <ol className="space-y-4">
            {steps.map((step, i) => <li key={i} data-index={i} className="flex items-start gap-3 text-muted-foreground">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary text-sm font-bold">
                  {i + 1}
                </span>
                <span className="text-base md:text-lg">{step.text}</span>
              </li>)}
          </ol>
        </div>

        <div className="flex justify-center">
          <Button asChild size="lg" className="rounded-lg px-8">
            <Link to="/">Return to Home</Link>
          </Button>
        </div>
      </div>
    </section>;
}